/* eslint-disable */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {loginUserWithPin, setUserPinCode} from '../../api/productService';
import { useAuthStore } from '../../store/useAuthStore';
import './PinCodeSetUp.css';
import {useToast} from "../../hooks/useToast";

const ConfirmPinCodePage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {showSuccess} = useToast();
  const [pin, setPin] = React.useState(['', '', '', '']);
  const setToken = useAuthStore((state) => state.setToken);

  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const inputsRef = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const originalPin = location.state?.pin;
  const originalEmail = location.state?.email

  React.useEffect(() => {
    if (!originalPin) {
      navigate('/set-pin');
    }
  }, [originalPin, navigate]);

  const handleChange = (idx: number, value: string) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newPin = [...pin];
    newPin[idx] = value;
    setPin(newPin);
    setError('');
    if (value && idx < 3) {
      // @ts-ignore
      inputsRef[idx + 1].current?.focus();
    }
  };

  const handleKeyDown = (idx: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !pin[idx] && idx > 0) {
      // @ts-ignore
      inputsRef[idx - 1].current?.focus();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pin.some(d => d === '')) {
      setError(t('pin.error_length'));
      return;
    }
    if (pin.join('') !== originalPin) {
      setError(t('pin.error_mismatch') || 'Pin codes do not match.');
      return;
    }
    setLoading(true);
    try{
      await setUserPinCode(pin.join(''), originalEmail);
      showSuccess('Pin code set up success!')
    }catch(error){
      setError(t('pin.error_backend') || 'Failed to set pin code.');
    }
    try {
      const result = await loginUserWithPin(originalEmail, pin.join(''))
      setToken(result.jwt)
      navigate('/dashboard');
    } catch (err:any) {
      if(err?.status === 423){
        setTimeout(() => {
          window.location.href = `${process.env.REACT_APP_FUNNEL_URL}/checkout`;
        }, 4000)
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pin-setup-container">
      <div className="pin-setup-icon">
        <img src="/images/key-round.png" alt="Key icon" width={96} height={96} style={{ display: 'block' }} />
      </div>
      <h2 className="pin-setup-title">{t('pin.confirm_title') || t('pin.title')}</h2>
      <div className="pin-setup-instructions">
        <div>{t('pin.confirm_instructions_line1')}</div>
        <div>{t('pin.confirm_instructions_line2')}</div>
      </div>
      <form className="pin-setup-form" onSubmit={handleSubmit} autoComplete="off">
        <div className="pin-setup-inputs">
          {pin.map((digit, idx) => (
            <input
              key={idx}
              ref={inputsRef[idx]}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={1}
              className="pin-setup-input"
              value={digit}
              onChange={e => handleChange(idx, e.target.value)}
              onKeyDown={e => handleKeyDown(idx, e)}
              autoFocus={idx === 0}
              disabled={loading}
            />
          ))}
        </div>
        {error && <div className="pin-setup-error">{error}</div>}
        <button
          type="submit"
          className="pin-setup-continue"
          disabled={pin.some(d => d === '') || loading}
        >
          {loading ? t('pin.loading') || 'Loading...' : t('pin.continue') || 'CONTINUE'}
        </button>
      </form>
    </div>
  );
};

export default ConfirmPinCodePage;
